export var extrairCodigoArea = function (telefone) {
    var resultado = telefone.match(/\((\d+)\)/);
    return resultado ? resultado[1] : undefined;
};
export var extrairNumero = function (telefone) {
    return telefone.replace(/\(\d+\)\s*/, "");
};
export var formatDate = function (dateString) {
    if ((dateString === null || dateString === void 0 ? void 0 : dateString.length) !== 8) {
        throw new Error("A string deve ter 8 caracteres no formato 'YYYYMMDD'.");
    }
    var year = dateString.slice(0, 4);
    var month = dateString.slice(4, 6);
    var day = dateString.slice(6, 8);
    return "".concat(day, "/").concat(month, "/").concat(year);
};
export var formatName = function (input) {
    if (input) {
        return input === null || input === void 0 ? void 0 : input.toLowerCase().split(" ").map(function (word) { var _a; return ((_a = word === null || word === void 0 ? void 0 : word.charAt) === null || _a === void 0 ? void 0 : _a.call(word, 0).toUpperCase()) + (word === null || word === void 0 ? void 0 : word.slice(1)); }).join(" ");
    }
};
